<template>
    <div>
        <h2>Incident List</h2>

        <b-container>
            <b-row>
                <b-col sm="10">
                    <b-input-group class="filter-group">
                        <b-form-input v-model="filter" placeholder="Type to Search" class="filter-input" />
                        <b-input-group-append>
                            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col sm="2">
                    <b-button :to="{ name: 'incidentForm' }" class="btn-primary pull-right">New Incident</b-button>
                </b-col>
            </b-row>
        </b-container>

        <b-table striped
                 hover
                 :items="incidents"
                 :fields="fields"
                 :per-page="perPage"
                 :current-page="currentPage"
                 :sort-compare="customSort"
                 :filter="filter"
                 @filtered="onFiltered"
                 responsive>
            <template slot="createdDate" slot-scope="data">
                {{data.item.createdDate | moment("MM-DD-YYYY")}}
            </template>
            <template slot="submitterId" v-if="isAdmin()">
            </template>
            <template slot="userName" slot-scope="data">
                {{data.item.submitter.firstName}} {{data.item.submitter.lastName}}
            </template>
            <template slot="studentName" slot-scope="data">
                {{data.item.student.firstName}} {{data.item.student.lastName}}
            </template>
            <template slot="lastName" slot-scope="data">
                {{data.item.student.lastName}}
            </template>
            <template slot="firstName" slot-scope="data">
                {{data.item.student.firstName}}
            </template>
            <template slot="subjectCode" slot-scope="data">
                {{data.item.studentCourse.subjectCode}}
            </template>
            <template slot="catalogNumber" slot-scope="data">
                {{data.item.studentCourse.catalogNumber}}
            </template>
            <template slot="termCode" slot-scope="data">
                {{data.item.studentCourse.termCode}}
            </template>
            <template slot="status" slot-scope="data">
                {{getCurrentStatusName(data.item.incidentStatuses)}}
            </template>
            <template slot="details" slot-scope="data">
                <router-link :to="{ name: 'incident', params: { incidentId: data.item.id }}">Details</router-link>
            </template>
        </b-table>
        <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" align="center"></b-pagination>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      fields: [
        { key: "createdDate", label: "Submitted On", sortable: true },
        { key: "submitterId", label: "User ASURITE", sortable: true },
        { key: "userName", sortable: true },
        { key: "department", sortable: true },
        { key: "studentId", label: "Student ASURITE", sortable: true },
        { key: "studentName", sortable: true },
        { key: "lastName", sortable: true },
        { key: "firstName", sortable: true },
        { key: "major", sortable: true },
        { key: "subjectCode", sortable: true },
        { key: "catalogNumber", sortable: true },
        { key: "termCode", label: "Term", sortable: true },
        { key: "status", sortable: true },
        { key: "details", label: "", sortable: false }
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      filter: null
    };
  },

  props: {
    incidents: {
      type: Array,
      required: true
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  watch: {
    incidents: function() {
      this.totalRows = this.incidents.length;
    }
  },

  methods: {
    isAdmin: function() {
      return _.find(this.user.userRoles, function(userRole) {
        return userRole === "Incidents.Admin";
      });
    },

    customSort(a, b, key) {
      if (key === "userName") {
        var nameA = a.submitter.firstName + " " + a.submitter.lastName;
        var nameB = b.submitter.firstName + " " + b.submitter.lastName;
        return nameA.localeCompare(nameB);
      } else if (key === "studentName") {
        var studentNameA = a.student.firstName + " " + a.student.lastName;
        var studentNameB = b.student.firstName + " " + b.student.lastName;
        return studentNameA.localeCompare(studentNameB);
      } else if (key === "lastName") {
        var lastNameA = a.student.lastName;
        var lastNameB = b.student.lastName;
        return lastNameA.localeCompare(lastNameB);
      } else if (key === "firstName") {
        var firstNameA = a.student.firstName;
        var firstNameB = b.student.firstName;
        return firstNameA.localeCompare(firstNameB);
      } else if (key === "subjectCode") {
        var codeA = a.studentCourse.subjectCode;
        var codeB = b.studentCourse.subjectCode;
        return codeA.localeCompare(codeB);
      } else if (key === "catalogNumber") {
        var numA = a.studentCourse.catalogNumber;
        var numB = b.studentCourse.catalogNumber;
        return numA < numB ? -1 : numA > numB ? 1 : 0;
      } else if (key === "termCode") {
        var termA = a.studentCourse.termCode;
        var termB = b.studentCourse.termCode;
        return termA < termB ? -1 : termA > termB ? 1 : 0;
      } else {
        return null;
      }
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getCurrentStatusName(statuses) {
      if (statuses.length > 0) {
        return statuses[0].incidentStatusDefinition.name;
      }
      return null;
    }
  },

  created() {
    // fields are different depending on user roles
    if (!this.isAdmin()) {
      _.remove(this.fields, function(field) {
        return (
          field.key === "submitterId" ||
          field.key === "userName" ||
          field.key === "department" ||
          field.key === "studentId" ||
          field.key === "studentName" ||
          field.key === "termCode"
        );
      });
    } else {
      _.remove(this.fields, function(field) {
        return (
          field.key === "lastName" ||
          field.key === "firstName" ||
          field.key === "major"
        );
      });
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 100%;
}

.filter-input {
  width: 300px;
  max-width: 80%;
  flex: none !important;
}

.filter-group {
  margin: 10px 0 10px 0;
}

.form-control {
  display: inline-block;
  width: 300px !important;
}

.new-incident-btn {
  float: right;
}
</style>
